'use es6';

import UILink from 'UIComponents/link/UILink';
import FormattedMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { DashboardFloatingAlertStore } from '../../shared/DashboardFloatingAlertStore';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getGoToDashboardLink = goToDashboard => {
  return !goToDashboard ? null : /*#__PURE__*/_jsx(UILink, {
    onClick: goToDashboard,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `reportActions.goToLink.goToDashboard`
    })
  });
};
const showActionAlert = (type, {
  message,
  options = {},
  goToDashboard,
  displayRedirectLink = true
}) => {
  if (displayRedirectLink) {
    DashboardFloatingAlertStore.addAlert({
      message: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(View, {
          marginInlineEnd: "100",
          as: "span",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: message,
            options: options
          })
        }), getGoToDashboardLink(goToDashboard)]
      }),
      type,
      'data-test-id': 'report-save-success-alert'
    });
  } else {
    DashboardFloatingAlertStore.addAlert({
      message: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: message,
        options: options
      }),
      type
    });
  }
};
export const showSuccessNotification = (params = {}) => {
  showActionAlert('success', params);
};
export const showFailureNotification = (params = {}) => {
  showActionAlert('danger', params);
};
export const showMoveSuccessNotification = (reportName, dashboardName, goToDashboard) => {
  showSuccessNotification({
    message: 'reportActions.move.success',
    options: {
      reportName,
      dashboardName
    },
    goToDashboard
  });
};
export const showMoveFailureNotification = () => {
  showFailureNotification({
    message: 'reportActions.move.failure'
  });
};
export const showAddSuccessNotification = (reportName, dashboardName, goToDashboard, displayRedirectLink = true) => {
  showSuccessNotification({
    message: 'reportActions.add.success.single',
    options: {
      reportName,
      dashboardName
    },
    goToDashboard,
    displayRedirectLink
  });
};
export const showBulkAddSuccessNotification = (dashboardName, goToDashboard, displayRedirectLink = true) => {
  showSuccessNotification({
    message: 'reportActions.add.success.multi',
    options: {
      dashboardName
    },
    goToDashboard,
    displayRedirectLink
  });
};
export const showAddFailureNotification = () => {
  showFailureNotification({
    message: 'reportActions.add.failure'
  });
};